// extracted by mini-css-extract-plugin
export default {"tag":"hcF2jV2","tag--default":"Cl8uSM5","tag--disabled":"J8zpsFv","tag--lime":"Jp9iJP7","tag__button":"kaHLnbe","tag__icon":"aYxQeHb"};